import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { SolicitudesApi } from "../api/SolicitudesApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { FiltrosSolicitudes } from "./FiltrosSolicitudes";
import { SolicitudesTable } from "./SolicitudesTable";
import { ModalRepeticionAnalisis } from "./ModalRepeticionAnalisis";
import { ModalHistorialRepeticiones } from "./ModalHistorialRepeticiones";
import { useRepeticionAnalisis } from "../hooks/useRepeticionAnalisis";
import { useHistorialRepeticiones } from "../hooks/useHistorialRepeticiones";

import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";

export const ListaSolicitudes = ({
    storageKey,
    estadoSolicitudes,
    nombreAcopio,
}) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";
    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [solicitudesPendientes, setSolicitudesPendientes] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getSolicitudesLaboratorio, cargando } = SolicitudesApi();

    const GetSolicitudesPendientesAnalisis = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
                estado: estadoSolicitudes,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getSolicitudesLaboratorio(params);
            setSolicitudesPendientes(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener solicitudes pendientes de análisis",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setSolicitudesPendientes([]);
            setCantidadResultados(0);
        }
    };

    const repeticion = useRepeticionAnalisis({
        onRepeticionCompletada: GetSolicitudesPendientesAnalisis,
    });

    const historial = useHistorialRepeticiones();

    useEffect(() => {
        GetSolicitudesPendientesAnalisis();
    }, [paginaSeleccionada, debouncedSearch, fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    return (
        <div className="pendientes-analisis__tab-wrapper">
            <LoadMask loading={cargando || repeticion.cargando} blur>
                <CardEmpty noShadow>
                    <div
                        className="d-flex justify-content-end "
                        style={{ gap: "5px" }}
                    >
                        <label>Acopio:</label>
                        <span>{nombreAcopio}</span>
                    </div>

                    <div className="pendientes-analisis__table-header">
                        <FiltrosSolicitudes
                            control={control}
                            onRefresh={() => {
                                GetSolicitudesPendientesAnalisis();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"ID Solicitud"}
                        />
                    </div>

                    <SolicitudesTable
                        solicitudesPendientes={solicitudesPendientes}
                        estadoSolicitudes={estadoSolicitudes}
                        repeticion={repeticion}
                        historial={historial}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>

            {estadoSolicitudes === "HISTORIAL" && (
                <ModalRepeticionAnalisis repeticion={repeticion} />
            )}

            <ModalHistorialRepeticiones historial={historial} />
        </div>
    );
};
